<template>
  <div class="browse-home-data">
    <table>
      <thead>
      <tr class="sub-header">
        <th style="width: 25%"></th>
        <th class="text-left" style="width: 35%">Critère</th>
        <th style="width: 9%">Période N</th>
        <th style="width: 9%">Période N-1</th>
        <th style="width: 9%">Var.</th>
        <th style="width: 9%"><p class="position-relative m-0 p-0">Total N-1 <span class="position-absolute" style="bottom: -10px; right: 0">circo</span></p></th>
        <th style="width: 9%;" class="national-col">National N</th>
        <th style="width: 30px"></th>
      </tr>
      </thead>

      <tbody>
      <template v-for="bigCategory in tree">
        <tr :key="`${bigCategory.id}:header`">
          <td colspan="8" class="category-header">{{ bigCategory.label }}</td>
        </tr>

        <template v-for="critere in bigCategory.children">
          <tr
              :key="`${bigCategory.id}:${critere.id}:parent`"
              class="parent-row"
              @click="toggleCritere(critere.id)"
          >
            <td>
              <input
                  v-if="showCheckboxes"
                  class="mr-2"
                  type="checkbox"
                  :value="critere.key"
                  v-model="checkedProxy"
                  @click.stop
              />
              <span v-if="hasClassement(critere)" class="toggle-icon">
                  {{ isCritereOpen(critere.id) ? '▼' : '▶' }}
                </span>
              <span v-else class="toggle-icon"></span>
              <span class="round-classement" v-if="critere.rank">
                    {{ critere.rank }}
                  </span>
              {{ critere.category }}
            </td>

            <td class="text-left not-bold">
              <p class="position-relative m-0">{{ critere.label }}
              <span
                  v-if="critere.refreshFrequency === 'MENSUEL'"
                  class="text-primary maj-mensuel"
                  style="font-size: 10px;"
              >
                  Mis à jour mensuellement
                </span>
              </p>
            </td>

            <td>{{ critere.moisN }}</td>
            <td class="not-bold">{{ critere.moisN1 }}</td>

            <td>
                <span :class="trendClass(critere.diffRaw)">
                  {{ formatSigned(critere.diffRaw) }}
                </span>
            </td>

            <td class="not-bold">{{ critere.totalN1 }}</td>
            <td>{{ critere.nationalValue }}</td>

            <td style="color: #006AA2" @click.stop="emitShowGraph(critere)">
              <i class="far fa-chart-bar"></i>
            </td>
          </tr>

          <template v-for="(child, index) in (critere.classement || [])">
            <tr
                :key="`${bigCategory.id}:${critere.id}:child:${index}`"
                class="child-row"
                v-show="isCritereOpen(critere.id)"
                @click="toggleChild(critere.id, index, child)"
                v-if="child.name"
            >
              <td colspan="2">
                  <span v-if="child.children && child.children.length > 0" class="toggle-icon">
                    {{ isChildOpen(critere.id, index) ? '▼' : '▶' }}
                  </span>

                <span :class="(!child.children || child.children.length === 0) ? 'ml-4' : ''" class="round-classement">
                    {{ child.rank }}
                  </span>
                {{ child.name }}
                <span class="text-primary">{{ child.type }}</span>
                <span class="text-primary">{{ child.codePtf }}</span>
              </td>

              <td>{{ formatNumber(child.value) }}</td>
              <td class="not-bold">{{ child.valueN1 != null ? formatNumber(child.valueN1) : '-' }}</td>

              <td>
                  <span :class="trendClass(child.diff)">
                    {{ child.diff != null ? formatSigned(child.diff) : '-' }}
                  </span>
              </td>

              <td class="not-bold">{{ child.totalN1 != null ? formatNumber(child.totalN1) : '-' }}</td>
              <td></td>

              <td style="color: #006AA2" @click.stop="child.id ? emitShowGraph(critere, child) : null">
                <i v-if="child.id" class="far fa-chart-bar"></i>
              </td>
            </tr>

            <template v-for="(subChild, indexSubChild) in (child.children || [])">
              <tr
                  :key="`${bigCategory.id}:${critere.id}:sub:${index}:${indexSubChild}`"
                  class="sub-child-row"
                  v-show="isCritereOpen(critere.id) && isChildOpen(critere.id, index)"
                  @click="toggleSubChild(critere.id, index, indexSubChild, subChild)"
              >
                <td colspan="2">
                    <span v-if="subChild.children && subChild.children.length > 0" class="toggle-icon">
                      {{ isSubChildOpen(critere.id, index, indexSubChild) ? '▼' : '▶' }}
                    </span>

                  <span :class="(!subChild.children || subChild.children.length === 0) ? 'ml-4' : ''" class="round-classement">
                      {{ subChild.rank }}
                    </span>
                  {{ subChild.name }}
                  <span class="text-primary">{{ subChild.type }}</span>
                  <span class="text-primary">{{ subChild.codePtf }}</span>
                </td>

                <td>{{ formatNumber(subChild.value) }}</td>
                <td class="not-bold">{{ subChild.valueN1 != null ? formatNumber(subChild.valueN1) : '-' }}</td>

                <td>
                    <span :class="trendClass(subChild.diff)">
                      {{ subChild.diff != null ? formatSigned(subChild.diff) : '-' }}
                    </span>
                </td>

                <td class="not-bold">{{ subChild.totalN1 != null ? formatNumber(subChild.totalN1) : '-' }}</td>
                <td></td>

                <td style="color: #006AA2" @click.stop="subChild.id ? emitShowGraph(critere, subChild) : null">
                  <i v-if="subChild.id" class="far fa-chart-bar"></i>
                </td>
              </tr>

              <template v-for="(lastChild, indexLastChild) in (subChild.children || [])">
                <tr
                    :key="`${bigCategory.id}:${critere.id}:last:${index}:${indexSubChild}:${indexLastChild}`"
                    class="last-child-row"
                    v-show="isCritereOpen(critere.id) && isChildOpen(critere.id, index) && isSubChildOpen(critere.id, index, indexSubChild)"
                >
                  <td colspan="2">
                    <span class="toggle-icon"></span>
                    <span class="round-classement">{{ lastChild.rank }}</span>
                    {{ lastChild.name }}
                    <span class="text-primary">{{ lastChild.type }}</span>
                    <span class="text-primary">{{ lastChild.codePtf }}</span>
                  </td>


                  <td>{{ formatNumber(lastChild.value) }}</td>
                  <td class="not-bold">{{ lastChild.valueN1 != null ? formatNumber(lastChild.valueN1) : '-' }}</td>

                  <td>
                      <span :class="trendClass(lastChild.diff)">
                        {{ lastChild.diff != null ? formatSigned(lastChild.diff) : '-' }}
                      </span>
                  </td>

                  <td class="not-bold">{{ lastChild.totalN1 != null ? formatNumber(lastChild.totalN1) : '-' }}</td>
                  <td></td>

                  <td style="color: #006AA2" @click.stop="lastChild.id ? emitShowGraph(critere, lastChild) : null">
                    <i v-if="lastChild.id" class="far fa-chart-bar"></i>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'IndicatorsTreeTable',
  props: {
    tree: { type: Array, required: true },
    value: { type: Array, default: () => [] }, // v-model
    showCheckboxes: { type: Boolean, default: true },
  },
  data() {
    return {
      expandedCriteres: {},
      expandedChildren: {},
      expandedSubChildren: {},
    };
  },
  computed: {
    checkedProxy: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  methods: {
    emitShowGraph(critere, objectData = null) {
      this.$emit('show-graph', {critere: critere, objectData: objectData});
    },
    hasClassement(critere) {
      return Array.isArray(critere.classement) && critere.classement.length > 0;
    },

    keyChild(critereId, index) {
      return `${critereId}__${index}`;
    },
    keySubChild(critereId, index, indexSubChild) {
      return `${critereId}__${index}__${indexSubChild}`;
    },

    isCritereOpen(critereId) {
      return !!this.expandedCriteres[critereId];
    },
    isChildOpen(critereId, index) {
      return !!this.expandedChildren[this.keyChild(critereId, index)];
    },
    isSubChildOpen(critereId, index, indexSubChild) {
      return !!this.expandedSubChildren[this.keySubChild(critereId, index, indexSubChild)];
    },

    closeDescendantsOfCritere(critereId) {
      Object.keys(this.expandedChildren).forEach((k) => {
        if (k.startsWith(`${critereId}__`)) this.$delete(this.expandedChildren, k);
      });
      Object.keys(this.expandedSubChildren).forEach((k) => {
        if (k.startsWith(`${critereId}__`)) this.$delete(this.expandedSubChildren, k);
      });
    },
    closeDescendantsOfChild(critereId, index) {
      const prefix = `${critereId}__${index}__`;
      Object.keys(this.expandedSubChildren).forEach((k) => {
        if (k.startsWith(prefix)) this.$delete(this.expandedSubChildren, k);
      });
    },

    toggleCritere(critereId) {
      if (!this.isCritereOpen(critereId)) {
        this.$set(this.expandedCriteres, critereId, true);
        return;
      }
      this.$delete(this.expandedCriteres, critereId);
      this.closeDescendantsOfCritere(critereId);
    },

    toggleChild(critereId, index, child) {
      if (!child || !child.children || child.children.length === 0) return;

      const key = this.keyChild(critereId, index);

      if (!this.expandedChildren[key]) {
        this.$set(this.expandedChildren, key, true);
        return;
      }
      this.$delete(this.expandedChildren, key);
      this.closeDescendantsOfChild(critereId, index);
    },

    toggleSubChild(critereId, index, indexSubChild, subChild) {
      if (!subChild || !subChild.children || subChild.children.length === 0) return;

      const key = this.keySubChild(critereId, index, indexSubChild);

      if (!this.expandedSubChildren[key]) {
        this.$set(this.expandedSubChildren, key, true);
        return;
      }
      this.$delete(this.expandedSubChildren, key);
    },

    formatNumber(v) {
      if (v === null || v === undefined || v === '') return '-';
      const n = Number(v);
      if (Number.isNaN(n)) return '-';
      return Math.round(n).toLocaleString();
    },
    formatSigned(v) {
      if (v === null || v === undefined || v === '') return '-';
      const n = Number(v);
      if (Number.isNaN(n)) return '-';
      const rounded = Math.round(n);
      return rounded > 0 ? `+${rounded.toLocaleString()}` : rounded.toLocaleString();
    },
    trendClass(diff) {
      const n = Number(diff);
      if (Number.isNaN(n) || n === 0) return 'trend-egual';
      return n > 0 ? 'trend-up' : 'trend-down';
    },
  },
};
</script>